// ACTION_TYPES ////////////////////////////////////////////////////////////////

export const MODAL_PREFIX = 'MODAL';
export const MODAL_PATIENT_MODIFICATION_WARNING_OPEN_ACTION = `${MODAL_PREFIX}_PATIENT_MODIFICATION_WARNING_OPEN_ACTION`;
export const MODAL_PATIENT_MODIFICATION_WARNING_CLOSE_ACTION = `${MODAL_PREFIX}_PATIENT_MODIFICATION_WARNING_CLOSE_ACTION`;

// INITIAL STATE ///////////////////////////////////////////////////////////////

const initialState = {
  IS_OPEN_PATIENT_MODIFICATION_WARNING: false,
  PATIENT_MODIFICATION_WARNING_ID: ''
};

// STATE ///////////////////////////////////////////////////////////////////////
export default (state = initialState, action) => {
  switch (action.type) {
    case MODAL_PATIENT_MODIFICATION_WARNING_OPEN_ACTION:
    case MODAL_PATIENT_MODIFICATION_WARNING_CLOSE_ACTION:
      return {
        ...state,
        IS_OPEN_PATIENT_MODIFICATION_WARNING: action.payload.open,
        PATIENT_MODIFICATION_WARNING_ID: action.payload.id
      };

    default:
      return state;
  }
};

// ACTIONS /////////////////////////////////////////////////////////////////////

export function openPatientModificationWarning(id) {
  return dispatch => {
    dispatch({
      type: MODAL_PATIENT_MODIFICATION_WARNING_OPEN_ACTION,
      payload: { open: true, id }
    });
  };
}

export function closePatientModificationWarning(id) {
  return dispatch => {
    dispatch({
      type: MODAL_PATIENT_MODIFICATION_WARNING_CLOSE_ACTION,
      payload: { open: false, id }
    });
  };
}
